import React from 'react';

import { FacetPill } from 'src/components/atoms/FacetPill/FacetPill';
import { HorizontalScroller } from 'src/components/molecules/HorizontalScroller/HorizontalScroller';
import type { UIFacet } from 'src/components/types/UIFacet';
import * as styles from './DynamicFacetPills.styles';

export interface DynamicFacetPillsProps {
  facets: UIFacet[];
  onPillClick: (facetKey: string) => void;
  openFacetKey?: string | null;
}

export const DynamicFacetPills = ({
  facets,
  onPillClick,
  openFacetKey = null,
}: DynamicFacetPillsProps) => {
  if (facets.length === 0) {
    return null;
  }

  return (
    <HorizontalScroller ariaLabel="Filters" testId="dynamic-facet-pills">
      <div css={styles.pillList}>
        {facets.map((facet) => (
          <FacetPill
            activeCount={facet.options.filter((option) => option.active).length}
            icon={facet.key === openFacetKey ? 'expanded' : 'collapsed'}
            key={facet.key}
            onClick={() => onPillClick(facet.key)}
            title={facet.title}
          />
        ))}
      </div>
    </HorizontalScroller>
  );
};
